"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemRarity = exports.ItemType = void 0;
/**
 * Types of game items
 */
var ItemType;
(function (ItemType) {
    ItemType["Resource"] = "resource";
    ItemType["Weapon"] = "weapon";
    ItemType["Helmet"] = "helmet";
    ItemType["Pants"] = "pants";
    ItemType["Shirt"] = "shirt";
    ItemType["Clothing"] = "clothing";
})(ItemType || (exports.ItemType = ItemType = {}));
var ItemRarity;
(function (ItemRarity) {
    ItemRarity["Common"] = "common";
    ItemRarity["Good"] = "good";
    ItemRarity["Rare"] = "rare";
    ItemRarity["Epic"] = "epic";
    ItemRarity["Legendary"] = "legendary";
})(ItemRarity || (exports.ItemRarity = ItemRarity = {}));
